import React from 'react';
import { useReveal } from '../lib/useReveal';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/tsuBuspmt7zdV2qXRAbk4r/heylloyd-image-1774028573119.png';
const BG_IMG = 'https://cdn.magicpatterns.com/uploads/mw6kDR1fciKdF9Qhz1AMu6/heylloyd-image-1774029715790.png';
export function HeroSection() {
  const [ref1, vis1] = useReveal();
  return <section className="min-h-screen pt-20 pb-12 md:pt-28 md:pb-16 px-5 sm:px-6 overflow-hidden relative flex flex-col justify-center" data-id="element-170">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `url(${BG_IMG})`
    }} data-id="element-171"></div>
      <div className="absolute inset-0 bg-black/88" data-id="element-172"></div>

      <div ref={ref1} className={`reveal container mx-auto max-w-4xl text-center relative z-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-173">
        {/* Top Badge */}
        <div className="mb-8" data-id="element-174">
          <span className="text-[#f0c040] text-xs md:text-sm font-bold tracking-[0.2em] uppercase" data-id="element-175">
            ⭐ ACADEMIA HOLÍSTICA ARGENTINA ⭐
          </span>
        </div>

        {/* Title */}
        <h1 className="mb-6 font-serif font-bold tracking-tight leading-none text-white" data-id="element-176">
          <span className="block text-3xl sm:text-4xl md:text-5xl lg:text-6xl mb-2" data-id="element-177">
            Tu formación completa de
          </span>
          <span className="block text-[#eab308] text-5xl sm:text-6xl md:text-7xl lg:text-8xl" data-id="element-178">
            Reiki.
          </span>
        </h1>

        {/* Subtitle */}
        <p className="text-gray-300 mb-6 max-w-3xl mx-auto leading-relaxed px-2 text-lg md:text-xl font-medium" data-id="element-179">
          ¿Y si pudieras aprender Reiki de verdad — sin viajar, sin horarios,
          sin pagar fortunas — y tener todo lo que necesitás para practicar,
          cobrar y crecer desde hoy? El sistema más completo en español, de cero
          a Maestro/a, a tu ritmo y con garantía total.
        </p>

        {/* Product Image */}
        <div className="block mx-auto max-w-xs sm:max-w-md md:max-w-lg mb-8" data-id="element-180">
          <div className="relative animate-float" data-id="element-181">
            <div className="relative p-1 rounded-2xl bg-gradient-to-br from-[#eab308]/30 via-white/5 to-[#eab308]/20 shadow-[0_12px_60px_rgba(0,0,0,0.6)] border border-white/10" data-id="element-182">
              <div className="rounded-xl overflow-hidden bg-black" data-id="element-183">
                <img src={PRODUCT_IMG} alt="Sistema Maestría Reiki" className="w-full object-cover block mix-blend-screen" data-id="element-184" />
              </div>
            </div>
          </div>
        </div>

        {/* Quote */}
        <p className="text-[#eab308] font-serif font-bold italic text-xl md:text-2xl tracking-wide mb-6" data-id="element-185">
          "Listo para aprender. Sin experiencia previa."
        </p>

        {/* Social Proof */}
        <p className="text-gray-300 mb-8 max-w-2xl mx-auto leading-relaxed px-2 text-base md:text-lg" data-id="element-186">
          El sistema que ya eligieron{' '}
          <span className="text-white font-bold" data-id="element-187">+1.000 alumnos</span> en
          Argentina para formarse en Reiki desde cero.
        </p>

        {/* Pill Badges */}
        <div className="flex flex-wrap justify-center gap-3 sm:gap-4 mb-6" data-id="element-188">
          <span className="flex items-center gap-2 text-xs md:text-sm text-gray-200 font-medium bg-white/5 border border-white/15 rounded-full px-4 py-1.5 backdrop-blur-sm" data-id="element-189">
            📱 100% Digital
          </span>
          <span className="flex items-center gap-2 text-xs md:text-sm text-gray-200 font-medium bg-white/5 border border-white/15 rounded-full px-4 py-1.5 backdrop-blur-sm" data-id="element-190">
            ⚡ Acceso inmediato
          </span>
          <span className="flex items-center gap-2 text-xs md:text-sm text-gray-200 font-medium bg-white/5 border border-white/15 rounded-full px-4 py-1.5 backdrop-blur-sm" data-id="element-191">
            🎓 De cero a Maestro/a
          </span>
        </div>

        {/* CTA */}
        <div className="flex flex-col items-center gap-3 w-full max-w-xl mx-auto" data-id="element-192">
          <a href="#pricing-offer" className="w-full block px-4 sm:px-6 py-4 md:py-5 rounded-xl text-[#0f0f1a] font-bold text-sm sm:text-base md:text-lg tracking-wider sm:tracking-widest uppercase transition-all shadow-[0_0_30px_rgba(234,179,8,0.4)] hover:shadow-[0_0_40px_rgba(234,179,8,0.6)] hover:-translate-y-1 bg-[#eab308] hover:bg-[#d4a017] border border-[#eab308]/50 text-center" style={{
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-193">
            🔥 QUIERO EL SISTEMA MAESTRÍA REIKI
          </a>

          <p className="text-gray-400 text-xs md:text-sm font-medium mt-2" data-id="element-194">
            💳 Mercado Pago — Tarjeta de crédito — Transferencia
          </p>
          <p className="text-gray-500 text-xs md:text-sm font-medium mt-1" data-id="element-195">
            🔒 Pago seguro — Acceso inmediato — Garantía 7 días
          </p>
        </div>
      </div>
    </section>;
}